import ArrowRight from "assets/svg/arrow-right-2.svg";
import DotsVertical3 from "assets/svg/dots-vertical-3.svg";
import { FC, useEffect, useState } from "react";

import { generateUuidForReactList } from "../../src/utils";
import styles from "./style.module.css";

type Props = {
  totalCount: number;
  pageSize: number;
  onPageChange: any;
  selectedPage?: any;
};

const Pagination: FC<Props> = ({
  totalCount,
  pageSize,
  onPageChange,
  selectedPage,
}) => {
  const [selected, setSelected] = useState(1);
  const [pagesCount, setPagesCount] = useState(1);
  const [list, setList] = useState([]);
  const onPaginationClicked = (item: number) => {
    setSelected(item);
    onPageChange(+item);
  };
  useEffect(() => {
    onPagesCountHandler();
  }, [totalCount]);
  useEffect(() => {
    setSelected(1);
    onPagesCountHandler();
  }, [pageSize]);
  const onPagesCountHandler = () => {
    const totalPages =
      totalCount < pageSize ? 1 : Math.ceil(totalCount / pageSize);
    setPagesCount(totalPages);
  };
  useEffect(() => {
    generatePages();
  }, [selected, pagesCount, totalCount]);
  useEffect(() => {
    if (selectedPage) {
      setSelected(selectedPage);
    }
  }, [selectedPage]);
  const generatePages = () => {
    const list: any = [];
    if (totalCount > 0) {
      list.push(
        <button
          className={styles.prev}
          disabled={selected === 1}
          onClick={() => onPaginationClicked(selected - 1)}
          key={generateUuidForReactList()}
        >
          <ArrowRight className="inline-block h-full w-[8px] fill-current text-[#74788D]" />
        </button>
      );
      if (pagesCount <= 5) {
        for (let i = 1; i <= pagesCount; i++) {
          list.push(
            <button
              className={`${selected === i && styles.active}`}
              onClick={() => onPaginationClicked(i)}
              key={generateUuidForReactList()}
            >
              {i}
            </button>
          );
        }
      } else {
        if (selected > pagesCount - 3) {
          list.push(
            <button
              className={`${selected === 1 && styles.active}`}
              onClick={() => onPaginationClicked(1)}
              key={generateUuidForReactList()}
            >
              {1}
            </button>
          );
          list.push(
            <div className={styles.dots} key={generateUuidForReactList()}>
              <DotsVertical3 />
            </div>
          );
          for (let i = pagesCount - 3; i <= pagesCount; i++) {
            list.push(
              <button
                className={`${selected === i && styles.active}`}
                onClick={() => onPaginationClicked(i)}
                key={generateUuidForReactList()}
              >
                {i}
              </button>
            );
          }
        } else {
          const maxPage = selected < 3 ? 4 : selected + 2;
          const fromPage = selected < 3 ? 1 : selected - 1;
          for (let i = fromPage; i <= maxPage; i++) {
            list.push(
              <button
                className={`${selected === i && styles.active}`}
                onClick={() => onPaginationClicked(i)}
                key={generateUuidForReactList()}
              >
                {i}
              </button>
            );
          }
          list.push(
            <div className={styles.dots} key={generateUuidForReactList()}>
              <DotsVertical3 />
            </div>
          );
          list.push(
            <button
              className={`${selected === pagesCount && styles.active}`}
              onClick={() => onPaginationClicked(pagesCount)}
              key={generateUuidForReactList()}
            >
              {pagesCount}
            </button>
          );
        }
      }
      list.push(
        <button
          className={styles.next}
          disabled={selected === pagesCount}
          onClick={() => onPaginationClicked(selected + 1)}
          key={generateUuidForReactList()}
        >
          <ArrowRight className="inline-block h-full w-[8px] rotate-180 fill-current text-[#74788D]" />
        </button>
      );
    }
    setList(list);
  };
  return (
    <div className={`justify-center md:justify-start ${styles.container}`}>
      {list}
    </div>
  );
};
export default Pagination;
